import React from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/SessionWarning.css';

const SessionWarning = () => {
  const { sessionWarning, timeUntilExpiry, extendSession } = useAuth();

  if (!sessionWarning) {
    return null;
  }

  // Format the time remaining
  const formatTimeRemaining = (ms) => {
    if (!ms) return 'soon';
    
    const minutes = Math.floor(ms / (1000 * 60));
    
    if (minutes < 1) {
      return 'less than a minute';
    } else if (minutes === 1) {
      return '1 minute';
    } else {
      return `${minutes} minutes`;
    }
  };

  return (
    <div className="session-warning">
      <div className="session-warning-content">
        <h3>Session Expiring</h3>
        <p>
          Your session will expire in {formatTimeRemaining(timeUntilExpiry)}. 
          Would you like to stay logged in?
        </p>
        <div className="session-warning-actions">
          <button onClick={extendSession} className="extend-session-btn">
            Yes, Keep Me Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarning;
